import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'rmb-message-mail-template',
  templateUrl: './message-mail-template.component.html',
  styleUrl: './message-mail-template.component.scss',
  standalone: false,
})
export class MessageMailTemplateComponent {
  @Input() formGroup: FormGroup;
  @Input() fields: DynamicField[];
}

export interface DynamicField {
  type: 'input' | 'editor' | 'select' | 'chips';
  formControlName: string;
  label: string;
  placeholder?: string;
  fieldType?: 'M' | 'O' | '-';
  items?: SelectItem[];
}
